// FEATURES
var FILTER='filter';// CONTENTS
var PRICE_RANGE='price-range';// POSITIONS
var BEFORE='before';var AFTER='after';export var FILTER_PRICE_RANGE="".concat(FILTER,".").concat(PRICE_RANGE);export var FILTER_PRICE_RANGE_BEFORE="".concat(FILTER,".").concat(PRICE_RANGE,".").concat(BEFORE);export var FILTER_PRICE_RANGE_AFTER="".concat(FILTER,".").concat(PRICE_RANGE,".").concat(AFTER);